angular.module('jv.tracking.jobBoards.versionFAC', [])
    .factory('jobBoardVersionsFAC', [function () {
        return function(jobBoardVersions){
            var versionsList = [];
            for(var index in jobBoardVersions){
                var version = jobBoardVersions[index];
                if(version.add){
                    return -1;
                }
                versionsList.push(index*1);
            }
            return versionsList.sort().pop()+1;
        };
    }]);